import { SubscriptionApiBase } from './base';

export class SubscriptionInvoiceApi extends SubscriptionApiBase {
  list() {
    return super.get('invoice/', 'Failed to get subscription invoices');
  }
}
